import { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import useApi from "../../../services/useApi";
import AddModel from "../../../components/Add/AddModel";
import AddBottomButton from "../../../components/Add/AddBottomButton";
import { addMnoTarget } from "../components/types";
import AddInputs from "../../../components/Add/AddInputs";
import validateMandatoryFields from "../../../components/commonfunctions/validateMandatoryFields";
import { showToast } from "../../../components/toastMessage/toastSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { convertToISOFormat } from "../../../components/commonfunctions/convertDate";


export default function AddMnoTarget({ edit }: { edit?: boolean }) {
    const initialState: addMnoTarget = {
        etopup_from_date: '',
        etopup_to_date: '',
        etopup_target_value: '',
        bundle_from_date: '',
        bundle_to_date: '',
        bundle_target_value: '',
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id, targetId } = useParams();
    const { PostAPI, getAPI, PatchAPI } = useApi();
    const [loading, setLoading] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const entireResponse = useSelector((state: RootState) => state?.list?.entireResponse);
    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState(initialState)
    const [targetStatus, setTargetStatus] = useState('');
    const [targetType, setTargetType] = useState('');
    const pathname = useSelector((state: RootState) => state?.geolocation?.previousUrl);

    const inputFieldsForEtopup = {
        "eTop Up": {
            "From Date": {
                required: true,
                disabled: (!edit && !entireResponse?.etopup_enabled) || (edit && (targetType === "Bundle Activation" || (targetStatus === "Running" || targetStatus === "Expired"))),
                id: "etopup_from_date",
                type: "date",
                tabIndex: 0,
            },
            "To Date": {
                required: true,
                disabled: (!edit && !entireResponse?.etopup_enabled) || (edit && (targetType === "Bundle Activation" || (targetStatus === "Running" || targetStatus === "Expired"))),
                id: "etopup_to_date",
                type: "date",
                tabIndex: 0,
            },
            "eTop Up Target Value ": {
                required: true,
                disabled: (!edit && !entireResponse?.etopup_enabled) || (edit && targetType === "Bundle Activation"),
                id: "etopup_target_value",
                type: "currency",
                maxLength: 60,
                tabIndex: 0,
                placeholder: 'Enter amount'
            },
        },

    };
    const inputsFieldforBundle = {
        "Bundle Activation": {
            "From Date": {
                required: true,
                disabled: (!edit && !entireResponse?.bundle_activation_enabled) || (edit && (targetType !== "Bundle Activation" || (targetStatus === "Running" || targetStatus === "Expired"))),
                id: "bundle_from_date",
                type: "date",
                tabIndex: 0,

            },
            "To Date": {
                required: true,
                disabled: (!edit && !entireResponse?.bundle_activation_enabled) || (edit && (targetType !== "Bundle Activation" || (targetStatus === "Running" || targetStatus === "Expired"))),
                id: "bundle_to_date",
                type: "date",
                tabIndex: 0,
            },
            "Bundle Activation Target Value ": {
                required: true,
                disabled: (!edit && !entireResponse?.bundle_activation_enabled) || (edit && targetType !== "Bundle Activation"),
                id: "bundle_target_value",
                type: "currency",
                maxLength: 60,
                tabIndex: 0,
                placeholder: 'Enter amount'
            },
        },
    }


    //input hanllde rfor the feature
    const handleInputChange = (id: string, value: string) => {
        if (id === 'etopup_from_date' || id === 'etopup_to_date') {
            if (errors.etopup_to_date === `'From Date' should be greater than the 'To Date'.`) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    etopup_to_date: '',
                    etopup_from_date: '',
                }));
            }
        }
        if (id === 'bundle_from_date' || id === 'bundle_to_date') {
            if (errors.bundle_to_date === `'From Date' should be greater than the 'To Date'.`) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    bundle_to_date: '',
                    bundle_from_date: '',
                }));
            }
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: '',
        }));
        setState((prevState) => ({
            ...prevState,
            [id]: value,
        }));

    };

    const handleSubmit = async () => {
        try {
            setErrors(initialState);
            const eTopUpKeys = ['etopup_from_date', 'etopup_to_date', 'etopup_target_value'];
            const bundleKeys = ['bundle_from_date', 'bundle_to_date', 'bundle_target_value'];

            const isAnyFilled = (keys: string[]) =>
                keys.some(key => state[key] !== '' && state[key] !== null && state[key] !== undefined);

            let errorCheckKeys: string[] = [];

            if (isAnyFilled(eTopUpKeys)) {
                errorCheckKeys = [...errorCheckKeys, ...eTopUpKeys];
            }

            if (isAnyFilled(bundleKeys)) {
                errorCheckKeys = [...errorCheckKeys, ...bundleKeys];
            }
            if (errorCheckKeys.length === 0) {
                dispatch(showToast({
                    message: "Please fill atleast one field",
                    type: "error",
                }))
                return;
            }
            const errorObject = validateMandatoryFields(state, errorCheckKeys);
            if (Object.keys(errorObject).length > 0) {
                setErrors(errorObject);
                return;
            }
            if (state.etopup_from_date && new Date(state.etopup_to_date) < new Date(state.etopup_from_date)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    etopup_to_date: `'To Date' should be greater than the 'From Date'.`,
                    etopup_from_date: ' ',
                }));
                return;
            }
            if (state.bundle_from_date && new Date(state.bundle_to_date) < new Date(state.bundle_from_date)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    bundle_to_date: `'To Date' should be greater than the 'From Date'.`,
                    bundle_from_date: ' ',
                }));
                return;
            }
            //checking for values greater than 0
            if (state?.etopup_target_value !== '' && Number(state.etopup_target_value) < 1) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    etopup_target_value: 'Target value should be greater than 1',
                }));
                return;
            }
            if (state?.bundle_target_value !== '' && Number(state.bundle_target_value) < 1) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    bundle_target_value: 'Target value should be greater than 1',
                }));
                return;
            }
            let payload = {}
            if (edit) {
                if (targetType === "Bundle Activation") {
                    if (targetStatus === 'Running' || targetStatus === 'Expired') {
                        payload = {
                            is_target_update: true,
                            bundle_target_value: Number(state?.bundle_target_value),
                        }
                    } else {
                        payload = {
                            is_target_update: true,
                            bundle_from_date: state?.bundle_from_date,
                            bundle_to_date: state?.bundle_to_date,
                            bundle_target_value: Number(state?.bundle_target_value),
                        }
                    }

                } else {
                    if (targetStatus === 'Running' || targetStatus === 'Expired') {
                        payload = {
                            is_target_update: true,
                            etopup_target_value: Number(state?.etopup_target_value),
                        }
                    } else {
                        payload = {
                            is_target_update: true,
                            etopup_from_date: state?.etopup_from_date,
                            etopup_to_date: state?.etopup_to_date,
                            etopup_target_value: Number(state?.etopup_target_value),
                        }
                    }

                }
            } else {
                payload = {
                    ...(state.etopup_from_date !== '' && {
                        etopup_from_date: state?.etopup_from_date,
                        etopup_to_date: state?.etopup_to_date,
                        etopup_target_value: Number(state?.etopup_target_value),
                    }),
                    ...(state?.bundle_from_date !== '' && {
                        bundle_from_date: state?.bundle_from_date,
                        bundle_to_date: state?.bundle_to_date,
                        bundle_target_value: Number(state?.bundle_target_value),
                    })
                }
            }
            setLoading(true);
            let response;
            if (edit) {
                response = await PatchAPI(`mnos/${id}`, payload);
            } else {
                response = await PostAPI(`mnos/targets/${id}`, payload);
            }

            if (!response.error) {
                dispatch(showToast({
                    message: edit ? "Mno target updated succesfully" : response?.data?.message,
                    type: "success",
                }));
                navigate(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`);
            } else {
                dispatch(showToast({
                    message: response?.data?.response?.data?.message,
                    type: "error",
                }))
            }
            setLoading(false);
        } catch (error) {
            dispatch(showToast({
                message: "Something went wrong.",
                type: "error",
            }))
        }
    };

    const getDetails = async () => {
        setEditLoading(true)
        let response = await getAPI(`mnos/targets/${id}/${targetId}`);
        let data = response?.data?.data;
        let requiredObject: addMnoTarget;
        if (data?.target_type === 'Bundle Activation') {
            requiredObject = {
                bundle_from_date: convertToISOFormat(data?.from_date),
                bundle_to_date: convertToISOFormat(data?.to_date),
                bundle_target_value: data?.target_amount.toString(),
                etopup_from_date: '',
                etopup_to_date: '',
                etopup_target_value: '',
            }
            setState(requiredObject);
        } else {
            requiredObject = {
                etopup_from_date: convertToISOFormat(data?.from_date),
                etopup_to_date: convertToISOFormat(data?.to_date),
                etopup_target_value: (data?.target_amount).toString(),
                bundle_from_date: '',
                bundle_to_date: '',
                bundle_target_value: '',
            }
        }
        setState(requiredObject);
        setTargetStatus(data?.target_achieved_status);
        setTargetType(data?.target_type);
        setEditLoading(false);
    }
    useEffect(() => {
        if (edit) {
            getDetails();
        } else {
            if (entireResponse?.etopup_enabled === undefined && entireResponse?.bundle_activation_enabled === undefined) {
                navigate(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`);
            }
        }
    }, [])

    return (
        <div>
            <Breadcrumbs
                navPath={["MNO Management", "List of MNO's", "View Details", "View On Target Achievement", `${edit ? "Edit" : "Add"} MNO Target`]}
                heading={`${edit ? "Edit" : "Add"} MNO Target`}
                noNavigation
                links={[pathname ? pathname : "/mno-management/list-of-mnos", pathname ? pathname : "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`, `/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`]}
                hasAddPrivilege={true}
            />
            <AddModel>
                {(!edit || (edit && targetType !== "Bundle Activation")) && <AddInputs
                    inputs={inputFieldsForEtopup}
                    totalInputCount={7}
                    // isDisabledField={id ? ['email_address'] : []}
                    inputValues={state}
                    onInputChange={handleInputChange}
                    mapping={true}
                    RequiredPostalCode={true}
                    errors={errors}
                    editLoading={editLoading}
                />}
                {!edit && !entireResponse?.etopup_enabled && <p className="text-body1 text-primary_text">Note: The eTop up target in running / not started state, so you cannot enter the details at this time.</p>}
                {(!edit || (edit && targetType === "Bundle Activation")) && <AddInputs
                    inputs={inputsFieldforBundle}
                    totalInputCount={7}
                    // isDisabledField={id ? ['email_address'] : []}
                    inputValues={state}
                    onInputChange={handleInputChange}
                    mapping={true}
                    RequiredPostalCode={true}
                    errors={errors}
                    editLoading={editLoading}
                />}
                {!edit && !entireResponse?.bundle_activation_enabled && <p className="text-body1 text-primary_text">Note: The bundle activation target is in running / not started state, so you cannot enter the details at this time.</p>}
            </AddModel>
            <AddBottomButton
                buttonWidth={'w-[140px]'}
                buttonName={`${edit ? "Update" : "Add"} `}
                buttonClass={`w-[140px] whitespace-nowrap`}
                onClick={handleSubmit}
                disabled={false}
                loading={loading}
                testID="add_target"
            />
        </div>
    );
}